(function () {
  const GIFTS = [
    { threshold: 108000, variantId: 43165492576369 },
    { threshold: 72000,  variantId: 43165492609137 },
    { threshold: 36000,  variantId: 43165492674673 },
  ];

  const ALL_GIFT_VARIANT_IDS = GIFTS.map(g => g.variantId);
  let isSyncing = false;
  let lastSubtotal = null;
  let isSyncingFetch = false;

  const originalFetch = window.fetch;
  window._originalFetch = originalFetch;

  async function getCart() {
    const res = await originalFetch('/cart.js');
    return res.json();
  }

  async function addToCart(variantId) {
    await originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
  }

  async function removeFromCart(lineItemKey) {
    await originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    });
  }

  async function triggerDrawerRefresh() {
    isSyncingFetch = true;
    try {
      var currentUrl = window.location.pathname;
      var cart = await getCart();
      var realItem = cart.items.find(function(item) {
        return !ALL_GIFT_VARIANT_IDS.includes(item.variant_id);
      });

      var anchorItem = realItem || cart.items[0];
      if (!anchorItem) return;

      var res = await originalFetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: anchorItem.key,
          quantity: anchorItem.quantity,
          sections: 'cart_data,mini_cart',
          sections_url: currentUrl
        }),
      });

      var data = await res.json();
      if (data.sections && T4SThemeSP && T4SThemeSP.Cart && T4SThemeSP.Cart.renderContents) {
        T4SThemeSP.Cart.renderContents(data.sections);
      }
    } finally {
      isSyncingFetch = false;
    }
  }

  async function syncGift() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await getCart();

      const subtotalSemBrinde = cart.items
        .filter(item => !ALL_GIFT_VARIANT_IDS.includes(item.variant_id))
        .reduce((sum, item) => sum + item.final_line_price, 0);

      if (subtotalSemBrinde === lastSubtotal) return;
      lastSubtotal = subtotalSemBrinde;

      const targetGift = GIFTS.find(g => subtotalSemBrinde >= g.threshold) || null;
      const targetVariantId = targetGift ? targetGift.variantId : null;

      const giftLines = cart.items.filter(item =>
        ALL_GIFT_VARIANT_IDS.includes(item.variant_id)
      );

      for (const line of giftLines) {
        if (line.variant_id !== targetVariantId) {
          await removeFromCart(line.key);
        }
      }

      if (!targetVariantId) {
        setTimeout(async function() {
          await triggerDrawerRefresh();
        }, 500);
        return;
      }

      const alreadyInCart = giftLines.some(item => item.variant_id === targetVariantId);
      if (!alreadyInCart) {
        await addToCart(targetVariantId);
      }

      setTimeout(async function () {
        await triggerDrawerRefresh();
        const updatedCart = await getCart();
        document.dispatchEvent(new CustomEvent('cart:update:count', {
          bubbles: true,
          detail: { count: String(updatedCart.item_count) }
        }));
      }, 500);

    } finally {
      isSyncing = false;
    }
  }

  window.fetch = async function (...args) {
    var result = await originalFetch.apply(this, args);
    var url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

    if (!isSyncingFetch && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      lastSubtotal = null;
      isSyncingFetch = true;
      setTimeout(async function() {
        await syncGift();
        isSyncingFetch = false;
      }, 500);
    }
    return result;
  };

  setInterval(syncGift, 2000);
  syncGift();
})();
